import {dateFromStringServerFormat, dateToHumanizeString, dateToString} from './extras-date';

export function formatValue(value: any, format: (v: any, ex?: any) => string, extra?: any): string {
  if (format) {
    return format(value, extra);
  }
  return `${value}`;
}

export function formatNumber(value: any, type = 'float'): string {
  let result = '-';
  if (value !== undefined && value !== null) {
    switch (type) {
      case 'float':
        result = parseFloat(value).toFixed(2);
        break;
      case 'integer':
        result = parseInt(value, 2).toString();
        break;
      default:
        result = value.toString();
    }
  }
  return result;
}

export function formatDate(d: Date | string, humanize: Boolean = false): string {
  if (!d) {
    return '';
  }
  if (d instanceof Date) {
  }
  else{
    d = dateFromStringServerFormat(d);
  }
  return humanize ? dateToHumanizeString(d) : dateToString(d);
}

export function putTableRowActionValue(column, obj, sources) {
  if(column.actionFormat)
    return column.actionFormat(obj, sources);
  return {value: column.name, text: column.name, icon: 'bomb'};
}
